import { render } from "./Menssage.vue?vue&type=template&id=ecf1a8ee&scoped=true"
import script from "./Menssage.vue?vue&type=script&lang=js"
export * from "./Menssage.vue?vue&type=script&lang=js"

import "./Menssage.vue?vue&type=style&index=0&id=ecf1a8ee&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecf1a8ee"]])

export default __exports__